export default __webpack_public_path__ + "static/media/double-arrow.aa4fbb21.svg";